import {badge2Boot} from "./badge2.boot.js";
import {appContext} from "./badge2.context.js";
import {LoggerService} from "./domain/logger.service";

badge2Boot()
  .then(() => {
    /** @type {LoggerService} */
    const logger = appContext.obtain(LoggerService);
    const msg = `Badge2 finished booting.\n${JSON.stringify(((window.authorizedby || {}).badge2 || {}).info)}`;
    if (logger) {
      logger.info('global/booted', msg);
    } else {
      console.debug(msg);
    }
  })
  .catch(error => {
    /** @type {LoggerService} */
    const logger = appContext.obtain(LoggerService);
    const msg = `Badge2 fatal error when booting.\n${JSON.stringify(((window.authorizedby || {}).badge2 || {}).info)}`;
    if (logger) {
      logger.error('global/boot-error', msg, () => ({ error }), error);
    } else {
      console.debug(msg);
      console.debug(error.toString());
    }
  });
